/**
 * Antidumb brain-power game.
 * Cheeky. The only benefit claims allowed are the authorised B6 and B12 ones.
 * Never "supports memory", "increases IQ" or "makes you smarter".
 * A marketing funnel, not a medical or psychological assessment.
 */
(function () {
  var ORDER = ['Logic', 'Numbers', 'Attention', 'Memory'];
  var STEPS = [
    'Take it at the same time each day.',
    'Have one serving with food.',
    'Scratch the day off the jar.',
    'Replay on day 7 and compare the clock.'
  ];
  var REPORTS = [
    {
      headline: 'The clock won.',
      read: 'You got {correct} of {n}. Rough, and still only today. The first circle does not ask you to be sharp. It asks you to show up.'
    },
    {
      headline: 'Present. Barely.',
      read: 'You got {correct} of {n}. A few landed. The rest left with the timer. That is a start, not a label.'
    },
    {
      headline: 'A fair mess.',
      read: 'You got {correct} of {n}. Enough to prove you were in the room. Not enough to frame.'
    },
    {
      headline: 'Halfway to a row.',
      read: 'You got {correct} of {n}. The middle of the set, which is where most honest days live.'
    },
    {
      headline: 'Even. Which is honest.',
      read: 'You got {correct} of {n}. Right around the middle of this game. Not a type. A Tuesday.'
    },
    {
      headline: 'Better than the coin toss.',
      read: 'You got {correct} of {n}. More right than wrong. The ones you missed were usually the ones you rushed.'
    },
    {
      headline: 'The row is forming.',
      read: 'You got {correct} of {n}. A clean run with a couple of blanks. Tomorrow is the interesting circle.'
    },
    {
      headline: 'Annoyingly sharp. Mostly.',
      read: 'You got {correct} of {n}. The misses are the interesting part. They are usually the glance, not the puzzle.'
    },
    {
      headline: 'Leave some for tomorrow.',
      read: 'You got {correct} of {n}. Very little left on the table. The jar does not care. It still wants a scratch.'
    },
    {
      headline: 'The whole jar, today.',
      read: 'You got {correct} of {n}. A full card. Enjoy it. The score expires when you close this. The habit does not.'
    }
  ];

  var klaviyoBound = false;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function track(name, detail) {
    var payload = detail || {};
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var entry = { event: name };
      Object.keys(payload).forEach(function (key) {
        entry[key] = payload[key];
      });
      window.dataLayer.push(entry);
    }
    document.dispatchEvent(new CustomEvent(name, { detail: payload }));
  }

  function ordinal(n) {
    var mod100 = n % 100;
    if (mod100 >= 11 && mod100 <= 13) return n + 'th';
    switch (n % 10) {
      case 1:
        return n + 'st';
      case 2:
        return n + 'nd';
      case 3:
        return n + 'rd';
      default:
        return n + 'th';
    }
  }

  function formatDate(date) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function readStore(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStore(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* Private mode can block storage. The report still renders. */
    }
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function reportFor(percentile) {
    return REPORTS[clamp(Math.floor(percentile / 10), 0, REPORTS.length - 1)];
  }

  function noteFor(pct) {
    if (pct >= 80) return 'sharp';
    if (pct >= 50) return 'solid';
    return 'needs work';
  }

  function boot(root) {
    if (!root || root.getAttribute('data-bp-ready') === 'true') return;
    var bank = document.getElementById('bp-questions');
    if (!bank) return;

    var questions;
    try {
      questions = JSON.parse(bank.textContent);
    } catch (error) {
      return;
    }
    if (!questions || !questions.length) return;

    ORDER = [];
    questions.forEach(function (question) {
      if (question.cat && ORDER.indexOf(question.cat) === -1) ORDER.push(question.cat);
    });
    var stepSource = root.getAttribute('data-bp-steps');
    if (stepSource) {
      var customSteps = stepSource.split('\n').map(function (step) {
        return step.trim();
      }).filter(Boolean);
      if (customSteps.length) STEPS = customSteps;
    }

    root.setAttribute('data-bp-ready', 'true');

    var state = {
      index: 0,
      answers: [],
      questionStarted: 0,
      timerId: null,
      pastPar: false,
      result: null
    };

    function $(selector) {
      return root.querySelector(selector);
    }

    function stopTimer() {
      if (state.timerId) {
        window.clearInterval(state.timerId);
        state.timerId = null;
      }
      var timer = $('[data-bp-timer]');
      if (timer) timer.classList.remove('is-late');
    }

    function show(name, skipFocus) {
      var screens = root.querySelectorAll('[data-bp-screen]');
      screens.forEach(function (screen) {
        screen.hidden = screen.getAttribute('data-bp-screen') !== name;
      });
      if (name !== 'quiz') stopTimer();
      root.classList.toggle('is-report', name === 'report');
      if (name === 'report') {
        var scroller = root.closest('.bp-dialog__scroll');
        if (scroller) scroller.scrollTop = 0;
      }
      if (skipFocus) return;
      var active = $('[data-bp-screen="' + name + '"]');
      var heading = active && active.querySelector('[data-bp-focus]');
      if (heading) heading.focus();
    }

    function startTimer(par) {
      stopTimer();
      state.questionStarted = Date.now();
      state.pastPar = false;
      var timer = $('[data-bp-timer]');
      var live = $('[data-bp-par-live]');
      if (live) live.textContent = '';

      function tick() {
        var seconds = (Date.now() - state.questionStarted) / 1000;
        if (timer) timer.textContent = (Math.round(seconds * 10) / 10).toFixed(1) + 's';
        if (!state.pastPar && seconds > par) {
          state.pastPar = true;
          if (timer) timer.classList.add('is-late');
          if (live) live.textContent = "Time's past par";
        }
      }

      tick();
      state.timerId = window.setInterval(tick, 100);
    }

    function renderQuestion() {
      var question = questions[state.index];
      $('[data-bp-cat]').textContent = question.cat;
      $('[data-bp-count]').textContent = state.index + 1 + ' / ' + questions.length;
      var progress = $('[data-bp-progress]');
      progress.setAttribute('aria-valuenow', String(state.index + 1));
      $('[data-bp-progress-fill]').style.width = ((state.index + 1) / questions.length) * 100 + '%';
      var heading = $('[data-bp-question]');
      heading.textContent = question.text;
      var figure = $('[data-bp-figure]');
      if (question.figure) {
        figure.hidden = false;
        figure.textContent = question.figure;
      } else {
        figure.hidden = true;
        figure.textContent = '';
      }
      $('[data-bp-par]').textContent = 'Par time for this one: ' + question.par + 's. Faster earns a bonus.';
      var answers = $('[data-bp-answers]');
      answers.innerHTML = '';
      question.opts.forEach(function (label, optIndex) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'bp-answer';
        button.textContent = label;
        button.addEventListener('click', function () {
          choose(optIndex);
        });
        answers.appendChild(button);
      });
      startTimer(question.par);
      heading.focus();
    }

    function choose(optIndex) {
      var buttons = root.querySelectorAll('.bp-answer');
      if (!buttons.length || buttons[0].disabled) return;
      buttons.forEach(function (button) {
        button.disabled = true;
      });
      var question = questions[state.index];
      var time = Math.round((Date.now() - state.questionStarted) / 100) / 10;
      stopTimer();
      var correct = optIndex === question.ans;
      var bonus = clamp(5 * (1 - time / question.par), 0, 5);
      var points = correct ? 10 + bonus : 0;
      state.answers.push({
        index: state.index,
        cat: question.cat,
        correct: correct,
        time: time,
        points: points
      });
      track('bp_answer', { index: state.index, correct: correct, time: time });
      if (state.index < questions.length - 1) {
        state.index += 1;
        renderQuestion();
        return;
      }
      finish();
    }

    function buildResult() {
      var total = 0;
      var totalTime = 0;
      var correctCount = 0;
      var underPar = 0;
      var pointsByCat = {};
      var countByCat = {};
      ORDER.forEach(function (cat) {
        pointsByCat[cat] = 0;
        countByCat[cat] = 0;
      });
      questions.forEach(function (question) {
        countByCat[question.cat] = (countByCat[question.cat] || 0) + 1;
      });
      state.answers.forEach(function (answer) {
        total += answer.points;
        totalTime += answer.time;
        if (answer.correct) correctCount += 1;
        if (answer.correct && answer.time <= questions[answer.index].par) underPar += 1;
        pointsByCat[answer.cat] += answer.points;
      });
      var maxPoints = Math.max(questions.length * 15, 1);
      var percentile = clamp(Math.round(100 / (1 + Math.exp(-9 * (total / maxPoints - 0.5)))), 4, 97);
      var categories = {};
      ORDER.forEach(function (cat) {
        var ceiling = Math.max((countByCat[cat] || 1) * 15, 1);
        var pct = clamp(Math.round((pointsByCat[cat] / ceiling) * 100), 0, 100);
        categories[cat] = { pct: pct, note: noteFor(pct) };
      });
      var weak = ORDER[0];
      ORDER.forEach(function (cat) {
        if (categories[cat].pct < categories[weak].pct) weak = cat;
      });
      return {
        total: Math.round(total * 10) / 10,
        percentile: percentile,
        correct: correctCount,
        avgTime: Math.round((totalTime / questions.length) * 10) / 10,
        totalTime: Math.round(totalTime * 10) / 10,
        categories: categories,
        weak: weak,
        underPar: underPar,
        report: clamp(Math.floor(percentile / 10), 0, REPORTS.length - 1),
        headline: reportFor(percentile).headline,
        date: formatDate(new Date())
      };
    }

    function showEmail(result) {
      state.result = result;
      $('[data-bp-done]').textContent = 'Done · ' + result.totalTime.toFixed(1) + 's total';
      $('[data-bp-blur]').textContent = String(result.percentile);
      show('email');
    }

    function showReport(result) {
      state.result = result;
      writeStore('bp:lastResult', JSON.stringify(result));
      writeStore('bp:unlocked', '1');
      var report = reportFor(result.percentile);
      $('[data-bp-date]').textContent = result.date;
      $('[data-bp-headline]').textContent = report.headline;
      $('[data-bp-read]').textContent = report.read
        .replace('{correct}', String(result.correct))
        .replace('{n}', String(questions.length));
      $('[data-bp-stat="percentile"]').textContent = result.percentile + '%';
      $('[data-bp-stat="correct"]').textContent = result.correct + '/' + questions.length;
      $('[data-bp-stat="avg"]').textContent = result.avgTime.toFixed(1);
      $('[data-bp-stat="par"]').textContent = result.underPar + '/' + questions.length;
      var soft = $('[data-bp-soft]');
      if (soft) {
        var scores = ORDER.map(function (cat) {
          return result.categories[cat] ? result.categories[cat].pct : 0;
        });
        var even = scores.every(function (score) {
          return score === scores[0];
        });
        soft.textContent = even ? 'Even across the four categories.' : 'Softest today: ' + result.weak + '.';
      }
      ORDER.forEach(function (cat) {
        var row = result.categories[cat];
        if (!row) return;
        var meta = root.querySelector('[data-bp-cat-meta="' + cat + '"]');
        var fill = root.querySelector('[data-bp-cat-fill="' + cat + '"]');
        if (meta) meta.textContent = row.pct + '% · ' + row.note;
        if (fill) fill.style.width = row.pct + '%';
      });
      var list = $('[data-bp-steps-list]');
      if (list) {
        list.innerHTML = '';
        STEPS.forEach(function (step) {
          var item = document.createElement('li');
          item.textContent = step;
          list.appendChild(item);
        });
      }
      show('report');
      track('bp_report_view', { report: result.report });
    }

    function finish() {
      var result = buildResult();
      writeStore('bp:lastResult', JSON.stringify(result));
      track('bp_complete', { score: result.total, percentile: result.percentile });
      var mode = root.getAttribute('data-email-mode');
      var unlocked = readStore('bp:unlocked') === '1';
      if (mode === 'none' || unlocked) {
        showReport(result);
        return;
      }
      showEmail(result);
    }

    function unlockFromEmail() {
      if (!state.result) {
        var saved = readStore('bp:lastResult');
        if (!saved) return;
        try {
          state.result = JSON.parse(saved);
        } catch (error) {
          return;
        }
      }
      showReport(state.result);
    }

    var start = $('[data-bp-start]');
    if (start) {
      start.addEventListener('click', function () {
        state.index = 0;
        state.answers = [];
        state.result = null;
        track('bp_start');
        show('quiz', true);
        renderQuestion();
      });
    }

    var again = $('[data-bp-again]');
    if (again) {
      again.addEventListener('click', function () {
        state.index = 0;
        state.answers = [];
        show('intro');
      });
    }

    var share = $('[data-bp-share]');
    if (share) {
      var shareLabel = share.textContent;
      var shareTimer = null;
      share.addEventListener('click', function () {
        var result = state.result;
        if (!result) return;
        var text = 'I scored the ' + ordinal(result.percentile) + ' percentile on Antidumb\'s brain power game. A game, not an IQ test. ' + window.location.href;
        function copied() {
          share.textContent = 'Link copied ✓';
          window.clearTimeout(shareTimer);
          shareTimer = window.setTimeout(function () {
            share.textContent = shareLabel;
          }, 2000);
        }
        if (navigator.share) {
          navigator.share({ title: 'Know your brain power.', text: text, url: window.location.href }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(copied).catch(function () {
            fallbackCopy(text, copied);
          });
          return;
        }
        fallbackCopy(text, copied);
      });
    }

    var cta = $('[data-bp-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        track('bp_cta_click');
      });
    }

    var form = $('[id="bp-email-form"]');
    if (form) {
      var input = form.querySelector('[data-bp-email]');
      var error = form.querySelector('[data-bp-email-error]');
      var tags = form.querySelector('[data-bp-tags]');
      var baseTags = tags ? tags.value : '';
      var settle = null;
      form.noValidate = true;
      if (error && error.hasAttribute('data-bp-server-error')) {
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', error.id);
      }

      var dialog = root.closest('dialog');
      var lifted = false;

      /* hCaptcha draws its challenge outside the dialog. A modal dialog makes that
         challenge inert and hides it under the top layer, so it opens non-modal
         while the check runs. */
      function liftDialog() {
        if (!dialog || !dialog.open || !dialog.matches(':modal')) return;
        lifted = true;
        dialog.close();
        dialog.show();
        dialog.classList.add('is-lifted');
      }

      function dropDialog() {
        if (!lifted || !dialog) return;
        lifted = false;
        dialog.classList.remove('is-lifted');
        if (!dialog.open) return;
        dialog.close();
        dialog.showModal();
        input.focus();
      }

      function serverError(html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('#bp-email-form [data-bp-email-error]');
          return node ? node.textContent.trim() : '';
        } catch (parseError) {
          return '';
        }
      }

      /* Shopify spam protection swaps form.submit for an hCaptcha step that adds a token
         and then calls the submit it found when it bound. Installing the fetch here, before
         the first focus binds hCaptcha, keeps the post native and the page in place. */
      var send = function () {
        var done = settle;
        settle = null;
        if (!done) return;
        dropDialog();
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = window.setTimeout(function () {
          if (controller) controller.abort();
          done(false, 'bp email timed out');
        }, 20000);
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: controller ? controller.signal : undefined
        }).then(function (response) {
          return response.text().then(function (html) {
            window.clearTimeout(timer);
            var url = response.url || '';
            if (url && new URL(url, window.location.href).pathname === '/challenge') {
              window.location.assign(url);
              return;
            }
            /* A bot check in front of the shop only clears in a real page load. The saved
               result in sessionStorage unlocks the report when Shopify redirects back. */
            if (response.status === 403 || response.status === 429) {
              HTMLFormElement.prototype.submit.call(form);
              return;
            }
            var saved = url.indexOf('customer_posted=true') !== -1 || html.indexOf('customer_posted=true') !== -1;
            done(saved, saved ? '' : serverError(html) || 'bp email status ' + response.status);
          });
        }).catch(function (info) {
          window.clearTimeout(timer);
          done(false, info);
        });
      };
      form.submit = send;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var value = input.value.trim();
        if (!validEmail(value)) {
          error.hidden = false;
          error.textContent = 'Enter a valid email to unlock the report.';
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', error.id);
          input.focus();
          return;
        }
        error.hidden = true;
        input.removeAttribute('aria-invalid');
        var note = form.querySelector('[data-bp-note]');
        if (state.result) {
          if (note) {
            note.value = 'Brain test: ' + ordinal(state.result.percentile) + ' percentile, ' + state.result.correct + ' of ' + questions.length + ' correct.';
          }
          if (tags) tags.value = baseTags + ', brain-test-score-' + state.result.correct;
        }
        track('bp_email_submit');
        var button = form.querySelector('[type="submit"]');
        var label = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = 'Saving…';
        }
        var finished = false;
        /* A visual hCaptcha challenge can take a while, and a dismissed one never calls back. */
        var checkTimer = window.setTimeout(function () {
          settle = null;
          finish(false, 'bp captcha not completed');
        }, 120000);
        var challengeSeen = false;
        var hiddenTicks = 0;
        var watch = window.setInterval(function () {
          if (!settle) return;
          var frame = document.querySelector('iframe[src*="hcaptcha"][src*="frame=challenge"]');
          var box = frame && frame.parentElement && frame.parentElement.parentElement;
          var visible = !!box && window.getComputedStyle(box).visibility === 'visible';
          if (visible) {
            challengeSeen = true;
            hiddenTicks = 0;
          } else if (challengeSeen && ++hiddenTicks >= 4) {
            settle = null;
            finish(false, 'bp captcha closed');
          }
        }, 500);
        function finish(saved, info) {
          if (finished) return;
          finished = true;
          window.clearTimeout(checkTimer);
          window.clearInterval(watch);
          dropDialog();
          if (button) {
            button.disabled = false;
            button.textContent = label;
          }
          if (saved) {
            error.hidden = true;
            unlockFromEmail();
            return;
          }
          error.hidden = false;
          error.textContent = typeof info === 'string' && info && info.indexOf('bp ') !== 0
            ? info
            : 'We could not save that email. Try again.';
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', error.id);
          console.error(info);
        }
        settle = finish;
        var captcha = window.Shopify && window.Shopify.captcha;
        if (form.hasAttribute('data-hcaptcha-bound')) {
          liftDialog();
          form.submit();
        } else if (captcha && typeof captcha.protect === 'function') {
          liftDialog();
          captcha.protect(form, function () {
            form.submit();
          });
        } else {
          send();
        }
      });
    }

    if (form && form.querySelector('[data-bp-posted]')) {
      writeStore('bp:unlocked', '1');
    }

    root.__bpStop = stopTimer;
    root.__bpOnKlaviyo = function (event) {
      if (root.getAttribute('data-email-mode') !== 'klaviyo_form') return;
      var detail = event.detail || {};
      if (detail.type !== 'submit') return;
      var expected = root.getAttribute('data-klaviyo-id');
      if (expected && detail.formId && String(detail.formId) !== String(expected)) return;
      track('bp_email_submit');
      unlockFromEmail();
    };

    var saved = readStore('bp:lastResult');
    var unlocked = readStore('bp:unlocked') === '1';
    if (saved && unlocked) {
      try {
        showReport(JSON.parse(saved));
      } catch (error) {
        show('intro');
      }
    } else if (saved && root.getAttribute('data-email-mode') !== 'none') {
      try {
        showEmail(JSON.parse(saved));
      } catch (error) {
        show('intro');
      }
    }
  }

  function fallbackCopy(text, done) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.left = '-999px';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
      done();
    } catch (error) {
      console.error(error);
    }
    document.body.removeChild(area);
  }

  function brainDialog() {
    return document.querySelector('[data-ad-brain-dialog]');
  }

  function openBrain() {
    var dialog = brainDialog();
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var start = dialog.querySelector('[data-bp-start]');
    if (start) start.focus();
  }

  function closeBrain() {
    var dialog = brainDialog();
    if (!dialog) return;
    var root = dialog.querySelector('[data-bp-root]');
    if (root && typeof root.__bpStop === 'function') root.__bpStop();
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  function bindBrainDialog() {
    var dialog = brainDialog();
    if (!dialog || dialog.getAttribute('data-ad-brain-bound') === 'true') return;
    dialog.setAttribute('data-ad-brain-bound', 'true');
    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-ad-brain-close]')) closeBrain();
    });
    dialog.addEventListener('close', function () {
      var root = dialog.querySelector('[data-bp-root]');
      if (root && typeof root.__bpStop === 'function') root.__bpStop();
    });
    document.addEventListener('click', function (event) {
      var trigger = event.target instanceof Element ? event.target.closest('[data-ad-brain-open], a[href="/pages/brain-power"]') : null;
      if (!trigger || !brainDialog()) return;
      event.preventDefault();
      openBrain();
    });
    if (
      document.querySelector('[data-ad-brain-page], [data-bp-posted], [data-bp-server-error]') ||
      window.location.hash === '#brain-test'
    ) {
      openBrain();
    }
  }

  function init() {
    document.querySelectorAll('[data-bp-root]').forEach(boot);
    bindBrainDialog();
  }

  if (!klaviyoBound) {
    klaviyoBound = true;
    window.addEventListener('klaviyoForms', function (event) {
      document.querySelectorAll('[data-bp-root]').forEach(function (root) {
        if (typeof root.__bpOnKlaviyo === 'function') root.__bpOnKlaviyo(event);
      });
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var dying = event.target && event.target.querySelector('[data-bp-root]');
      if (dying && typeof dying.__bpStop === 'function') dying.__bpStop();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
